import {
  action,
  observable
} from 'mobx'
import getStream from './getStream';
import utils from "@foxit/utils";
import { interviewInvitePost, interviewInvitePut } from '@/api/fwApi/webapi';
export default class office extends getStream {
  @observable isShowGuide = utils.util.getQueryString("registerName") && !localStorage.getItem('saveRegister')?true:false;
  @observable isShowSaveBtn = utils.util.getQueryString("registerName")?true:false;
  @observable isShowSaveSuccess = false;
  @action getIsShowGuide(isShowGuide){
    this.isShowGuide = isShowGuide
  }
  @action getIsShowSaveSuccess(isShowSaveSuccess){
    this.isShowSaveSuccess = isShowSaveSuccess
  }
  /**
   * 获取当前文件文件流
   * @returns 
   */
  @action fileToBlob() {
    return new Promise((resolve, reject)=>{
      this.getFileBlob().then(blob => {
        this.saveFile(blob).then(res=>{
          resolve(res)
        },err=>{
          reject(err)
        });
      });
    })
  }
  /**
   * 上传文件
   * @param {*} blob 文件流
   * @returns 
   */
  @action saveFile(blob) {
    const id = utils.util.getQueryString("registerId");
    const templateId = utils.util.getQueryString("templateId");
    const isDefault = JSON.parse(utils.util.getQueryString("isDefault"));
    const registerName = decodeURIComponent(utils.util.getQueryString("registerName"));
    const documentName = decodeURIComponent(decodeURIComponent(utils.util.getQueryString("documentName")));
    let formData = new FormData();
    formData.append("file", blob, documentName);
    formData.append("id", id);
    formData.append("name", registerName);
    formData.append("type", 2);
    formData.append("isDefault", isDefault);
    const config = {
      headers: {
        "Content-Type": "multipart/form-data;boundary = " + new Date().getTime()
      },
      params: formData,
      timeout:1000000
    };
    if(templateId){
      return new Promise((resolve, reject)=>{
        interviewInvitePut(config).then(res=>{
          resolve(res);
        },err=>{
          reject(err)
        })
      })
    } else {
      return new Promise((resolve, reject)=>{
        interviewInvitePost(config).then(res=>{
          resolve(res);
        },err=>{
          reject(err)
        })
      })
    }
  }
}